import { createStyles } from '@material-ui/core';

const styles = () =>
  createStyles({
    drawingBox: {
      display: 'inline-block',
      width: '90%',
      height: '125px',
      backgroundColor: 'white',
      justifySelf: 'center',
      gridArea: 'svgContainer',
      cursor: 'crosshair',
      touchAction: 'none'

      //dev only
      // borderWidth: "5px",
      // borderColor: "black",
      // borderStyle: "solid"
    },

    svgDrawing: {
      width: '100%',
      height: '100%'
    },

    readonly: {
      cursor: 'default',
      pointerEvents: 'none'
    }
  });

export default styles;
